import { render } from "./BrowserArchitectureComparison.vue?vue&type=template&id=5949f1e8&scoped=true"
import script from "./BrowserArchitectureComparison.vue?vue&type=script&lang=js"
export * from "./BrowserArchitectureComparison.vue?vue&type=script&lang=js"

import "./BrowserArchitectureComparison.vue?vue&type=style&index=0&id=5949f1e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5949f1e8"]])

export default __exports__